var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartIconColor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cart icon active",
    clipPath: "url(#clip0_1574_629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.9812 5.5998H12.6685L13.016 4.22838H4.37121V2.85695H13.9062C14.29 2.85695 14.6012 3.16396 14.6012 3.54266C14.6012 3.59873 14.5942 3.65458 14.5804 3.70898L12.8429 10.5661C12.7656 10.8714 12.4876 11.0855 12.1686 11.0855H2.28619C1.90235 11.0855 1.59119 10.7785 1.59119 10.3998V2.17123H0.201172V0.799805H2.28619C2.67004 0.799805 2.9812 1.10681 2.9812 1.48552V5.5998ZM2.9812 15.1998C2.21352 15.1998 1.59119 14.5858 1.59119 13.8284C1.59119 13.0709 2.21352 12.4569 2.9812 12.4569C3.74888 12.4569 4.37121 13.0709 4.37121 13.8284C4.37121 14.5858 3.74888 15.1998 2.9812 15.1998ZM11.3213 15.1998C10.5536 15.1998 9.93128 14.5858 9.93128 13.8284C9.93128 13.0709 10.5536 12.4569 11.3213 12.4569C12.089 12.4569 12.7113 13.0709 12.7113 13.8284C12.7113 14.5858 12.089 15.1998 11.3213 15.1998Z",
    fill: "#229986"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1574_629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(0.800781 0.799805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconColor);
export default __webpack_public_path__ + "static/media/Cart_icon_color.965ef6f4e50213dcaa17181551666b15.svg";
export { ForwardRef as ReactComponent };